import { Col, Row } from "react-bootstrap"
import PageTitle from "../PageTitle";
import Grid from "../../components/Grid/Grid";

/**
 * @param {string} path - Contém que irá se comunicar. 
 * @param {object} setEntityData - Armazena o objeto atual.
 */
const ListPage = (props) => {
    const { 
        route, path, motherMenu, activeMenu, columns, selectedBranch, multiBranchSupport, 
        customButtons, setSelectedRows, showPageTitle, height, hideDefaultButtons, setGridRef, filters,
        onDelete, rowSelection, hideRemove, hideInactiveToggle, beforeGrid, rowHeight
    } = props;

    return (
        <>
            {showPageTitle && <PageTitle activeMenu={activeMenu} motherMenu={motherMenu} />}
            <Row>
                <Col xl={12}>
                    <Grid height={ (height) ? height : "500px" } path={path}
                        columns={columns}
                        rowHeight={rowHeight}
                        rowSelection={rowSelection || "single"}
                        route={route}
                        customButtons={customButtons}
                        beforeGrid={beforeGrid}
                        pagination="true"
                        setSelectedRows={setSelectedRows}
                        hideDefaultButtons={hideDefaultButtons}
                        hideRemove={hideRemove}
                        hideInactiveToggle={hideInactiveToggle}
                        setGridRef={setGridRef}
                        filters={filters}
                        selectedBranch={selectedBranch}
                        multiBranchSupport={multiBranchSupport}
                        onDelete={onDelete}
                    />
                </Col>
            </Row>
        </>
    )
}

export default ListPage;
